<template>

  <div class="box-balance-resume">
    <div class="container">
      <div class="simulation-investment-resume -centered-info">
        <div class="row row-responsive">
          <div class="column column-sm-50">
            <span class="title">Total de clabes dadas de alta</span>
            <span class="value">{{ totalClabes }}</span>
          </div>
          <div class="column column-sm-50">
            <span class="title">Total de clabes activas</span>
            <span class="value">{{ totalActiveClabes }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'InvestorClabeResume',
  data () {
    return {
      totalActiveClabes: 0
    }
  },
  props: { totalClabes: Number },
  mixins: [httpRequestMixin],
  methods: {
    getUserClabes: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/investors/clabes/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          is_valid: true
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 200) {
        this.totalActiveClabes = response.data.results.length
      }
    }
  },
  created: function () {
    this.getUserClabes()
  }
}

</script>

<style lang="scss" scoped>

.simulation-investment-resume {
  margin: 2rem 0;
  padding: 0 2rem;
  border: 1px solid #ccc;
  border-radius: 6px;

  &.-background-dark {
    background-color: $midnight-blue;
    color: $white;
    border-radius: 6px;
  }

  .column {
    padding: 1rem 0 0;

    &:last-of-type {
      padding-bottom: 1rem;
    }
  }

  .title,
  .value {
    display: block;
  }
  .title {
    margin-bottom: .5rem;
    padding-bottom: .5rem;
    color: $midnight-blue;
    font-size: .9em;
    border-bottom: 1px solid #ccc;
  }
  .value {
    font-weight: bold;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/investorClabe/InvestorClabeResume.vue